// src/mocks/handlers/auth/passwordResetHandler.ts

import { rest } from 'msw';
import { PasswordResetRequestBody } from '@/domains/auth/auth.types';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { genericResponse } from '@/shared/types/api';

function generateDummyJwt() {
  const header = { alg: 'HS256', typ: 'JWT' };
  const payload = { sub: 34, exp: Math.floor(Date.now() / 1000) + 15 * 60 };
  const base64Encode = (obj: object) => btoa(JSON.stringify(obj));
  return `${base64Encode(header)}.${base64Encode(payload)}.signature`;
}

export const passwordResetHandler = rest.post<
  PasswordResetRequestBody,
  genericResponse
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.AUTH_RESET_PASSWORD}`,
  (req, res, ctx) => {
    // const { email } = req.body as { email: string };
    // JWT token for 15'
    const token = generateDummyJwt();

    /* eslint-disable no-console */
    /* print in console the generated token to use it in next step */
    console.log('Generated password reset token:', token);

    return res(
      ctx.status(202),
      ctx.json({
        message:
          'Please check your email for further instructions on how to reset the password.',
      }),
    );
  },
);
